<template>
<div class="col-12 md:col-6" v-if="project_supplier.flowsupplier">
<div class="flow_wrap raised_item animate_class px-4 py-3 mb-4 flow_wrap_active">


<div class="grid">

<div class="col-2"><h4 class="font-bold text-primary my-0">{{$store.state.languages.lang_phrases.proje}}:</h4></div>
<div class="col-10"><h4 class="font-bold text-purple-500 my-0">{{projectname}}</h4></div>

<div class="col-2"><h4 class="font-bold text-primary my-0">{{$store.state.languages.lang_phrases.proje_durumu}}:</h4></div>
<div class="col-10">

<Tag 
class=" custom-chip" 
:value="$store.state.languages.lang_phrases[project_status]" 
:style="'background-color:'+flowstatuscolor"
/>
</div>

<div class="col-2"><h4 class="font-bold text-primary my-0">{{$store.state.languages.lang_phrases.marka}}:</h4></div>
<div class="col-10"><h4 class="font-bold text-purple-500 my-0">{{project_supplier.flowsupplier.flow.brand.name}}</h4></div>

<div class="col-2"><h4 class="font-bold text-primary my-0">{{$store.state.languages.lang_phrases.tedarikci}}:</h4></div>
<div class="col-10"><h4 class="font-bold text-purple-500 my-0">{{project_supplier.supplier.name}} - {{project_supplier.supplier.suppliercode}}</h4></div>

</div>


<div class="grid section_wrap mt-2 home_flow_wrap">

<div class="col-12" v-for="flow in flows">
<div class="grid" >
	<div class="col-12 pt-1"><small class="text-primary font-bold mt-2">{{flow.flow.name}} </small></div>
	
	<div class="col-9 align-items-center justify-content-start flex mb-1">
	
	<Tag 
	class="  mb-2 custom-chip" 
	:value="getflowtype(flow)" 
	:style="'background-color:'+getflowtypecolor(flow)"
	/>

	<Tag 
	class="ml-2  mb-2 custom-chip" 
	:value="getFlowStatus(flow)" 
	:style="'background-color:'+getflowstatuscolor(flow)"
	/>

	<template v-if="project_supplier.activeflow_id ==flow.flow_id">  
	<Tag 
	class="ml-2 mb-2 custom-chip" 
	:value="$store.state.languages.lang_phrases.aktif" 
	style="background-color:#a82400"
	/>
	</template>
	
	</div>

  <div class="col-3 pt-1">
     <div class="flex justify-content-end ">
    <template v-if="flow.type=='audit'">
      <Button :label="$store.state.languages.lang_phrases.goster"  class="p-button-white  p-button-xs rightmargin" @click="gotoFlowSummary(flow.uuid)" ></Button>
    </template>

    <template v-else>
  <!-- expired -->
<template v-if="!daydifference(flow)">
  <template v-if="flow.status=='created'">
     <Button :label="$store.state.languages.lang_phrases.basla"  class="p-button-white  p-button-xs rightmargin " @click="gotoFlowSummary(flow.uuid)" ></Button>
   </template> 

   <template v-if="flow.status=='started' || flow.status=='viewed'">
     <Button :label="$store.state.languages.lang_phrases.devam_et"  class="p-button-white  p-button-xs rightmargin" @click="gotoFlowSummary(flow.uuid)" ></Button>
   </template>

   <template v-if="flow.status=='finished' || flow.status=='under_review' || flow.status=='correction_requested'">
     <Button :label="$store.state.languages.lang_phrases.goster"  class="p-button-white  p-button-xs rightmargin" @click="gotoFlowSummary(flow.uuid)" ></Button>
   </template> 
</template>

<template v-else>
   <template v-if="daydifference(flow).daysleft<=0">
    <template v-if="flow.status=='finished' || flow.status=='under_review' || flow.status=='correction_requested'">
     <Button :label="$store.state.languages.lang_phrases.goster"  class="p-button-white  p-button-xs rightmargin" @click="gotoFlowSummary(flow.uuid)" ></Button>
   </template> 
  </template>
  <!-- expired -->
<!-- not expired -->
  <template v-else>
    <template v-if="flow.status=='created'">
     <Button :label="$store.state.languages.lang_phrases.basla"  class="p-button-white  p-button-xs rightmargin " @click="gotoFlowSummary(flow.uuid)" ></Button>
   </template> 

   <template v-if="flow.status=='started' || flow.status=='viewed'">
     <Button :label="$store.state.languages.lang_phrases.devam_et"  class="p-button-white  p-button-xs rightmargin" @click="gotoFlowSummary(flow.uuid)" ></Button>
   </template>

   <template v-if="flow.status=='finished' || flow.status=='under_review' || flow.status=='correction_requested'">
     <Button :label="$store.state.languages.lang_phrases.goster"  class="p-button-white  p-button-xs rightmargin" @click="gotoFlowSummary(flow.uuid)" ></Button>
   </template> 
  </template>
  <!-- not expired -->
</template>



 
  
</template>
</div>
  </div>





	<div class="col-12 py-0 px-0">
    <template v-if="daydifference(flow)">
  <DateRangedisplay :daydifferencedata="daydifference(flow)" v-if="daydifference(flow)"></DateRangedisplay>
</template>

<div  v-if="!daydifference(flow)" style="height: 29px;"></div>
	</div>

<div class="col-12 p-0"><hr></div>


</div>
</div>
</div>


</div>
</div>
</template>

<script>
import moment from "moment"
import DateRangedisplay from "./DateRangedisplay"
export default {

  name: 'SupplierDashboardProjectWidget',
  components:{DateRangedisplay},
  props:["project_supplier","flowsuppliers"],
  data () {
    return {

    }
  },
  computed:{
  	
  	flowstatuscolor()
    {
      if(this.project_supplier.status=="created")
      {
        return "#352f8d"
      }
      if(this.project_supplier.status=="viewed")
      {
        return "#7e2f8d"
      }
      if(this.project_supplier.status=="started")
      {
        return "#dd4b39"
      }
      if(this.project_supplier.status=="finished")
      {
        return "#4dc247"
      }
      if(this.project_supplier.status=="under_review")
      {
        return "#ff6600"
      }
      if(this.project_supplier.status=="canceled")
      {
        return "#a82400"
      }
      if(this.project_supplier.status=="correction_requested")
      {
        return "#3b82f6"
      }
    },
  	project_status()
  	{
  		let status = this.project_supplier.status
  		if(status=="started")
  		{
  			return "beklemede"
  		}
  		if(status=="finished")
  		{
  			return "tamamlandi"
  		}
  		if(status=="created")
  		{
  			return "baslanmadi"
  		}
  	},
  	line_width()
  	{
  		console.log(this.flows.length)
  		if(this.flows.length===1)
  		{
  			return 0
  		}
  		else
  		{
  			return (this.flows.length)*(100/this.flows.length)
  		}
  		
  	},
  	projectname()
  	{
  		if(this.project_supplier.project.translations.length)
  		{
  			let translation = this.project_supplier.project.translations.find((item)=>{return item.language_id == this.$store.state.auth.user.preflang_id})
  			if(translation)
  			{
  				return translation.translation
  			}
  			return this.project_supplier.project.name
  		}
  		return this.project_supplier.project.name
  	},
  	flows()
  	{
  		let flows = []
  		for(let item of this.project_supplier.project.flows)
  		{
  			
  			let selected = this.flowsuppliers.find((element)=>{return element.flow_id == item.id })
  			if(selected)
  			{
  				flows.push(selected)
  			}
  		}
  		return flows
  	},
  },
  mounted()
  {

  },
  methods:{
    gotoFlowSummary(uuid)
    {
      this.$store.dispatch('evaluation/setMode',"supplier_viewing")
      this.$router.push({ name: 'SupplierBrandFlowSummary', params: { project_id:this.project_supplier.uuid,flow_id:uuid,supplier_uuid:this.project_supplier.supplier.uuid } })
    },
  	daydifference(flow)
  	{
  		let start
  		let end
  		let today = moment()
  		let diff
      let today_diff
      let days_left
      if(!flow.flow.start_date || !flow.flow.end_date)
      {
        return null
      }

  		if(flow.flow.start_date)
  		{
  			start = moment(flow.flow.start_date)
  		}

  		if(flow.flow.end_date)
  		{
  			end = moment(flow.flow.end_date)
  		}

  		if(start && end)
  		{
  			diff = end.diff(start, 'days') 
  		}
  		if(diff)
  		{
        today_diff = today.diff(start, 'days') 
        days_left = end.diff(today, 'days') 

  		}

  		if(today_diff)
  		{
  			days_left++
  			if(today<start)
  			{
  				return null
  			}
  			else
  			{
  				let data = Math.ceil((today_diff/diff)*100)
  				if(data>100) 
  				{
  					return {daydifference:100,daysleft:0}
  				}
  				else
  				{
  					return {daydifference:data,daysleft:days_left}
  				}
  			}
  			
  			
  		}
  		else
  		{
  			return null
  		}

  		
  	},
  	getFlowStatus(flow)
  	{
  		console.log("getFlowStatus")
  		console.log(flow)
  	  if(flow.status=="created")
      {
        return this.$store.state.languages.lang_phrases.olusturuldu
      }
      if(flow.status=="viewed")
      {
        return this.$store.state.languages.lang_phrases.goruntulendi
      }
      if(flow.status=="started")
      {
        return this.$store.state.languages.lang_phrases.baslandi
      }
      if(flow.status=="finished")
      {
        return this.$store.state.languages.lang_phrases.tamamlandi0
      }
      if(flow.status=="under_review")
      {
        return this.$store.state.languages.lang_phrases.degerlendirmede
      }
      if(flow.status=="canceled")
      {
        return this.$store.state.languages.lang_phrases.iptal_edildi
      }
      if(flow.status=="correction_requested")
      {
        return this.$store.state.languages.lang_phrases.duzeltme_talebi_incelemede
      }
  	},
  	getflowstatuscolor(flow)
  	{
  	  if(flow.status=="created")
      {
        return "#352f8d"
      }
      if(flow.status=="viewed")
      {
        return "#7e2f8d"
      }
      if(flow.status=="started")
      {
        return "#dd4b39"
      }
      if(flow.status=="finished")
      {
        return "#4dc247"
      }
      if(flow.status=="under_review")
      {
        return "#ff6600"
      }
      if(flow.status=="canceled")
      {
        return "#a82400"
      }
      if(flow.status=="correction_requested")
      {
        return "#3b82f6"
      }
  	},
  	getflowtype(flow)
  	{
  		if(flow.flow.type=="self_evaluation")
	      {
	        return this.$store.state.languages.lang_phrases.self_evaluation
	      }
	      if(flow.flow.type=="education")
	      {
	        return  this.$store.state.languages.lang_phrases.egitim
	      }
	      if(flow.flow.type=="verification")
	      {
	        return  this.$store.state.languages.lang_phrases.verification
	      }
	      if(flow.flow.type=="audit")
	      {
	        return  this.$store.state.languages.lang_phrases.audit
	      }
  	},
  	getflowtypecolor(flow)
  	{
  		if(flow.flow.type=="self_evaluation")
	      {
	        return "#ff6600"
	      }
	      if(flow.flow.type=="education")
	      {
	        return "#3b82f6"
	      }
	      if(flow.flow.type=="verification")
	      {
	        return "#7e2f8d"
	      }
	      if(flow.flow.type=="audit")
	      {
	        return "#352f8d"
	      }
  	}
  },
}
</script>

<style lang="css" scoped>
</style>